// helpers
import NFA from 'shared/helpers/analytics/NFAnalytics';

// constants
import { TRACK_TYPE } from 'shared/helpers/analytics/constants';
import { ACCOUNT_EVENTS } from 'shared/helpers/analytics/constants/accountEvents';

export const onPageLoad = () => {
  NFA.track({
    type: TRACK_TYPE.PAGELOAD,
    event: ACCOUNT_EVENTS.PAGELOAD,
  });
};
